import {ProjectConstants} from 'src/app/project-constants';

export class Offset  {
  pageSize: number;
  pageIndex: number;
  orderField: string = null;
  orderDirection: string = null;
  deltaFilter: number = null;
  actualQuantityFilter: number = null;

  constructor(pageSize?: number, pageIndex?: number, offsetType?: string) {

    if (!pageSize) {
      this.pageSize = 10;
    } else {
      this.pageSize = pageSize;
    }

    if (!pageIndex) {
      this.pageIndex = 0;
    } else {
      this.pageIndex = pageIndex;
    }

    const projectConstants: ProjectConstants = new ProjectConstants();

    if(offsetType){
      if (
        offsetType == projectConstants.OFFSET_NAME.CONSUNTIVO_VOLUMI_OFFSET ||
        offsetType == projectConstants.OFFSET_NAME.CONSUMPTIVE_CHARGES_OFFSET
      ) {
        //set default
        this.actualQuantityFilter = 1;
      }
    }

  }
}
